// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"10261a61","501":"76d0ef74","787":"c4ad2f38"}[chunkId] + ".chunk.js";
};